export class holiday {
  id: number;
  name: string;
  startDate: Date;
  endDate: Date;
}
